<template>
  <v-expansion-panels 
    :value="panels"
    @input="$emit('togglePanel', $event)"
    :readonly="true"
    flat
    class="mt-5"
  >
    <v-expansion-panel>
      <v-expansion-panel-header 
        class="display-flex pl-1 pr-3" 
        style="border-bottom: solid 1px #eee;" 
        hide-actions
      >       
        <div class="row">
          <div class="col-md-10">
            <h5 class="black--text" @click="togglePanel">
              <i class="aberto v-icon notranslate mdi mdi-chevron-down theme--light primary--text"></i>
              <i class="fechado v-icon notranslate mdi mdi-chevron-right theme--light primary--text"></i>
              Informações do Bloco: Nº {{ dadosFichaTecnica.pco_tarefa.ctrl_bloco_id }}
            </h5>
          </div>
          <div class="col-md-2 text-right">
            <SGPFormBotaoComponent small class="ml-2" @click="$emit('excluirBloco')">
              <v-icon color="white" small>mdi-trash-can-outline</v-icon>
              <span>Excluir Bloco</span>
            </SGPFormBotaoComponent>
          </div>
        </div>          
      </v-expansion-panel-header>
      
      <v-expansion-panel-content>
        <BlocoTableComponent :dadosFichaTecnica="dadosFichaTecnica" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import BlocoTableComponent from '../components/nova_ficha/BlocoTableComponent.vue';

export default {
  name: 'BlocoSection',
  
  components: {
    BlocoTableComponent
  },
  
  props: {
    dadosFichaTecnica: {
      type: Object,
      required: true
    },
    panels: {
      type: Number,
      default: 0
    }
  },
  
  methods: {
    togglePanel() {
      this.$emit('togglePanel');
    }
  }
}
</script>

<style lang="scss" scoped>
.theme--light.v-expansion-panels .v-expansion-panel {
  background: transparent !important;
}

.v-expansion-panel-header, .v-expansion-panel-content__wrap {
  padding: 0 !important;
}

.v-expansion-panel:before {
  box-shadow: none !important;
}

.v-expansion-panel-header .aberto {
  transition: display 5s linear;
  display: none !important;
}

.v-expansion-panel-header .fechado {
  display: inline !important;
}

.v-expansion-panel-header--active .aberto {
  transition: display 5s linear;
  display: inline !important;
}

.v-expansion-panel-header--active .fechado {
  display: none !important;
}
</style>
